compiler('[data-preview-credit-note-text], [data-preview-positions], [data-preview-text]', (element) => {
  const modelName = (function() {
    if (element.hasAttribute('data-preview-text')) {
      return element.getAttribute('data-preview-text');
    } else if (element.hasAttribute('data-preview-positions')) {
      return element.getAttribute('data-preview-positions');
    } else if (element.hasAttribute('data-preview-credit-note-text')) {
        return element.getAttribute('data-preview-credit-note-text');
    }
    return undefined;
  })();

  const orderInput = document.getElementById(`preview_search_${modelName}`);
  const csrf_token = document.head.querySelector('meta[name="csrf-token"][content]').content;

  function nextSibling(element, selector) {
    const nextElement = element.nextElementSibling;
    if (!selector) {
      return nextElement;
    }
    if (nextElement && nextElement.matches(selector)) {
      return nextElement;
    }
    return null;
  }

  function codeEditorValue(attributeName) {
    const inputElement = document.getElementsByName(`${modelName}[${attributeName}]`)[0];
    const editor = nextSibling(inputElement, ".CodeMirror");
    if(editor !== null) {
      return editor.CodeMirror.getValue();
    }
    return null;
  }

  element.addEventListener("click", function () {
    const formData = new FormData();
    formData.append("order_number", orderInput.value);

    // Check if the preview is for positions or text
    if (element.hasAttribute('data-preview-text')) {
      formData.append("prefix", codeEditorValue("text_prefix"));
      formData.append("append", codeEditorValue("text_append"));
    } else if (element.hasAttribute('data-preview-positions')) {
      formData.append("prefix", codeEditorValue("item_number_custom"));
      formData.append("append", codeEditorValue("item_title"));
    } else if (element.hasAttribute('data-preview-credit-note-text')) {
        formData.append("prefix", codeEditorValue("credit_note_text_prefix"));
        formData.append("append", codeEditorValue("credit_note_text_append"));
        formData.append("credit", true);
    }

    function getEndpoint() {
      if (element.hasAttribute('data-preview-text')) {
        return `/settings/preview_text`;
      } else if (element.hasAttribute('data-preview-positions')) {
          return `/settings/preview_positions`;
      } else if (element.hasAttribute('data-preview-credit-note-text')) {
        return `/settings/preview_text`;
      }
    }

    fetch(getEndpoint(), {
      method: 'POST',
      headers: {'X-CSRF-Token': csrf_token},
      body: formData,
    })
      .then(response => response.text())
      .then((modalContent) => {
        $("#modal_target").dynamic_modal(modalContent);
      }).catch(error => {
        console.error(`Couldn't get preview text for ${modelName}`, error);
    });
  });
});
